import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import { Badge, Popover } from 'antd';
import { MailOutlined, BellOutlined } from '@ant-design/icons';
import { loadNotifications } from '../../store/ducks/notifications/actions';
import { STORAGE } from 'utils/enums/storage.enum';
import { Link } from 'react-router-dom';

interface ContainerSelectInscricoesProps {
  show: boolean;
}

const Overlay = styled.div<ContainerSelectInscricoesProps>`
  display: ${(props) => (!props.show ? 'none' : 'block')};
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 8;
`;

const Title = styled.div`
  font-size: 14px;
  color: #1890ff;
`;

const Notifications: React.FC = () => {
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const notifications = useSelector((state: ApplicationState) => state.Notifications.notification);
  const { inscricaoAtiva } = useSelector((state: ApplicationState) => state.auth);

  useEffect(() => {
    if (inscricaoAtiva.length > 0) dispatch(loadNotifications(inscricaoAtiva));
  }, [dispatch, inscricaoAtiva]);

  const hide = async () => {
    setOpen(false);
    localStorage.setItem(STORAGE.Current_screen, '7');
  };

  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
  };

  const content = (
    <Link to="/dashboard/atendimento" onClick={hide}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <span style={{ fontWeight: 500, color: '#606060' }}>Atendimento</span>
        <Badge count={notifications} size="small" offset={[15, -6]}>
          <MailOutlined style={{ fontSize: '15px', marginLeft: '5px' }} />
        </Badge>
      </div>
    </Link>
  );

  return (
    <div onClick={() => setOpen(!open)} style={{ marginRight: '15px' }}>
      <Popover
        content={content}
        title={<Title>Notificações</Title>}
        trigger="click"
        visible={open}
        onVisibleChange={handleOpenChange}
      >
        <Badge dot={notifications > 0} offset={[-9, 9]}>
          <Overlay show={open} onClick={() => setOpen(!open)} />
          <BellOutlined style={{ fontSize: '20px', padding: '10px', cursor: 'pointer' }} />
        </Badge>
      </Popover>
    </div>
  );
};

export default Notifications;
